// src/store/globalLoadingSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalLoadingState {
  count: number; // number of in-flight API calls matched by middleware
  endpoint: string | null; // optional last endpoint name (friendly)
}

const initialState: GlobalLoadingState = { count: 0, endpoint: null };

const slice = createSlice({
  name: "globalLoading",
  initialState,
  reducers: {
    showGlobalLoading: (state, action: PayloadAction<{ endpoint?: string } | undefined>) => {
      state.count += 1;
      if (action?.payload?.endpoint) state.endpoint = action.payload.endpoint;
    },
    hideGlobalLoading: (state) => {
      state.count = Math.max(0, state.count - 1);
      if (state.count === 0) state.endpoint = null;
    },
    resetGlobalLoading: (state) => {
      state.count = 0;
      state.endpoint = null;
    },
  },
});

export const { showGlobalLoading, hideGlobalLoading, resetGlobalLoading } = slice.actions;
export default slice.reducer;
